module.exports = __webpack_public_path__ + "img/0Q3B3793_L_WoodMatted_MockedUp.b636de15.jpg";